import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Eye } from "../../assets/img/eye.svg";
import { BASE_URL } from "../../Config/api.config";
import RequestErrorModal from "../RequestErrorPopup";
const Password = ({ state, dispatch, adminData, setAdminData }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [warning, setWarning] = useState(false);
  let navigate = useNavigate();

  let data = new FormData();
  data.append("mode", "password");
  data.append("password", state.password);
  data.append("id", adminData.id);

  const checkPassword = () => {
    fetch(`${BASE_URL}login`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${adminData.uid}`,
      },
      body: data,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "ok") {
          setAdminData((prev) => ({ ...prev, uid: data.result.token }));
          submit();
        } else {
          setWarning(data.result.error_msg);
          setTimeout(() => {
            setWarning(false);
          }, 3800);
        }
      })
      .catch((err) => console.log(err));
  };

  function submit() {
    navigate("/admin-dashboard");
  }
  return (
    <>
      <div className="absolute top-0 left-[50%]">
        <RequestErrorModal warning={warning} />
      </div>
      <div className="relative w-full">
        <Eye
          className="absolute top-[36px] left-4 w-fit h-4 cursor-pointer"
          onClick={() => setShowPassword(!showPassword)}
        />
        <input
          type={showPassword ? "text" : "password"}
          autoFocus
          value={state.password}
          onChange={(e) =>
            dispatch({
              type: "UPDATE",
              value: e.target.value,
              key: "password",
            })
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              checkPassword();
            }
          }}
          className="w-full  outline-none border border-[#ADD8E6] mt-6 rounded h-10 px-12 text-sm"
          placeholder="Password"
        />
      </div>
      <div className="mt-8">
        <button
          type="button "
          onClick={() => checkPassword()}
          className="px-16 py-1.5  text-white bg-[#2abeeb] hover:bg-[#1d90b3]  rounded-full transition duration-300"
        >
          Log in
        </button>
      </div>
    </>
  );
};

export default Password;
